module.exports = __webpack_public_path__ + "img/2021.33906c9d.png";